<script>
  let {
    name,
    amount,
    currency = '₩',
    quantity = null,
    category = '',
    excluded = false,
    note = '',
  } = $props();

  let formattedAmount = $derived(amount.toLocaleString());
</script>

<div class="receipt-item-row" class:receipt-item-row--excluded={excluded}>
  <div class="receipt-item-row__main">
    <span class="receipt-item-row__left">
      {#if quantity != null}
        <span class="receipt-item-row__qty">{quantity}x</span>
      {/if}
      {#if category}
        <span class="receipt-item-row__cat-dot receipt-item-row__cat-dot--{category}"></span>
      {/if}
      <span class="receipt-item-row__name">{name}</span>
    </span>
    <span class="receipt-item-row__dots"></span>
    <span class="receipt-item-row__amount" class:receipt-item-row__amount--excluded={excluded}>
      {currency}{formattedAmount}
    </span>
  </div>
  {#if note}
    <div class="receipt-item-row__note">{note}</div>
  {/if}
</div>

<style>
  .receipt-item-row {
    width: 100%;
    margin-bottom: 0;
  }

  .receipt-item-row--excluded {
    opacity: 0.5;
    background: rgba(255, 59, 48, 0.06);
    border-radius: 2px;
    padding: 2px 4px;
    margin-left: -4px;
    margin-right: -4px;
  }

  .receipt-item-row__main {
    display: flex;
    align-items: baseline;
    gap: 4px;
    width: 100%;
    font-family: var(--font-mono);
    font-size: var(--receipt-size-body, 13px);
    color: var(--receipt-text-primary);
    height: 28px;
    line-height: 28px;
  }

  .receipt-item-row__left {
    display: flex;
    align-items: baseline;
    gap: 4px;
    flex-shrink: 0;
    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .receipt-item-row__qty {
    color: var(--receipt-text-muted);
    font-size: var(--receipt-size-meta, 11px);
    flex-shrink: 0;
  }

  .receipt-item-row__cat-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
    background: var(--receipt-text-muted);
  }
  .receipt-item-row__cat-dot--food { background: var(--receipt-cat-food, #2BA89E); }
  .receipt-item-row__cat-dot--transport { background: var(--receipt-cat-transport, #3A9FD6); }
  .receipt-item-row__cat-dot--accommodation { background: var(--receipt-cat-accom, #D45454); }
  .receipt-item-row__cat-dot--shopping { background: var(--receipt-cat-shopping, #C4A030); }
  .receipt-item-row__cat-dot--activity { background: var(--receipt-cat-activity, #5EAF9E); }
  .receipt-item-row__cat-dot--other { background: var(--receipt-text-muted); }

  .receipt-item-row__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .receipt-item-row__dots {
    flex: 1;
    min-width: 12px;
    border-bottom: 1px dotted var(--receipt-divider);
    margin-bottom: 4px;
  }

  .receipt-item-row__amount {
    font-family: var(--font-mono);
    font-variant-numeric: tabular-nums;
    letter-spacing: var(--receipt-ls-amount, 0.5px);
    white-space: nowrap;
    flex-shrink: 0;
  }

  .receipt-item-row__amount--excluded {
    text-decoration: line-through;
    color: var(--receipt-text-excluded, #FF3B30);
  }

  .receipt-item-row__note {
    font-family: var(--font-mono);
    font-size: var(--receipt-size-meta, 11px);
    color: var(--receipt-text-muted);
    padding-left: 16px;
    margin-top: 1px;
    line-height: 1.4;
  }
</style>
